/* eslint-disable no-alert */
/* eslint-disable react/jsx-wrap-multilines */
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import { Base64 } from 'js-base64'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import Collapse from '@material-ui/core/Collapse'
import { FiAlertCircle } from 'react-icons/fi'

import usePersistedState from '../../hooks/usePersistedState'
import api from '../../services/api'

import Button from '../../components/Button'
import Header from '../../components/Header'
import InputSMSCode from '../../components/InputSMSCode'

import Container from '../../components/Container'
import { DEFAULT_ACCESSION_CONFIG } from '../../utils/accessionConfig'
import {
  AccessionConfigData,
  ConfigData,
  UserData,
  UserDetails,
} from '../../utils/interfaces'
import { AlertContent, Content, LinkBack, Timer } from './styles'

const ConfirmSMS: React.FC = () => {
  const [userData, setUserData] = usePersistedState<UserData>(
    'userData',
    {} as UserData,
  )
  const [userDetails, setUserDetails] = usePersistedState<UserDetails>(
    'userDetails',
    {} as UserDetails,
  )
  const [configData, setConfigData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )
  const [accessionConfig] = usePersistedState<AccessionConfigData>(
    'accessionConfig',
    DEFAULT_ACCESSION_CONFIG,
  )

  const [reSend, setReSend] = useState(false)
  const [open, setOpen] = useState(false)
  const [invalidCodeAttempts, setInvalidCodeAttempts] = usePersistedState<
    number
  >('invalidCodeAttempts', 0)
  const [sizeCode] = usePersistedState<number>(
    'tamanhoCodigoValidador',
    accessionConfig.tamanhoCodigoValidador,
  )
  const [timer, setTimer] = useState(60)

  const history = useHistory()
  const formRef = useRef<FormHandles>(null)
  const contato = configData.tipoContato === 'S' ? 'SMS' : 'e-mail'

  const handleSubmit = useCallback(
    async data => {
      if (data.codeSMS.length === sizeCode) {
        const parametros = Base64.encode(
          `{"token": "${configData.token}",
          "codigoValidador": "${data.codeSMS}",
          "plano": "${configData.plano}",
          "cliente": "${configData.codCliente}",
          "cpf":"${userData.cpf.replaceAll('.', '').replace('-', '')}",
          "nascimento": "${userData.birthdate}",
          "patrocinadora":"${userData.patrocinadora}"}`,
        )

        const parametrosFinal = Base64.encode(parametros)

        await api
          .post(`wsAutenticacaoV4.rule?sys=ADZ&Entrada=${parametrosFinal}`)
          .then(res => {
            setInvalidCodeAttempts(0)
            setUserData({
              ...userData,
              name: res.data.nome,
              phone: res.data.telefone,
            })
            setUserDetails({
              ...userDetails,
              salario: Number(res.data.salario),
            })

            history.push('/start')
            // }
          })
          .catch(res => {
            if (res.message === 'Request failed with status code 401') {
              const nextAttempt = invalidCodeAttempts + 1

              if (nextAttempt >= 3) {
                setInvalidCodeAttempts(0)
                setConfigData({
                  ...configData,
                  token: '',
                })
                alert(
                  'Código incorreto 3 vezes. Solicite um novo código para continuar.',
                )
                history.push('/register')
                return
              }

              setInvalidCodeAttempts(nextAttempt)
              setOpen(true)
            } else {
              // eslint-disable-next-line no-alert
              alert('Ops, algo deu errado. Tente novamente mais tarde.')
            }
          })
      }
    },
    [
      configData,
      history,
      invalidCodeAttempts,
      setConfigData,
      setInvalidCodeAttempts,
      setUserData,
      setUserDetails,
      sizeCode,
      userData,
      userDetails,
    ],
  )

  useEffect(() => {
    const countTimer = (): void => {
      if (timer > 1) {
        setTimer(timer - 1)
      } else if (timer === 1) {
        setTimer(timer - 1)
        setReSend(true)
      }
    }

    const interval = setInterval(countTimer, 1000)

    return () => clearInterval(interval)
  }, [timer])

  const handleReSend = useCallback(async () => {
    const parametrosGet = Base64.encode(
      `{"versao":"${configData.tipo}",
        "plano": "${configData.plano}",
        "cliente":"${configData.codCliente}",
        "cpf":"${
          userData.cpf === undefined
            ? ''
            : userData.cpf.replaceAll('.', '').replace('-', '')
        }",
        "nascimento": "${userData.birthdate}",
        "patrocinadora":"${userData.patrocinadora}",
        "email":"${userData.email === undefined ? '' : userData.email}",
        "envio":"${configData.tipoContato}"}`,
    )

    const parametrosFinalGet = Base64.encode(parametrosGet)

    await api
      .get(`wsAutenticacaoV4.rule?sys=ADZ&Entrada=${parametrosFinalGet}`)
      .then(res =>
        setConfigData({
          ...configData,
          token: res.data.token,
        }),
      )
      .catch(() => alert('Ops, algo deu errado. Tente novamente mais tarde.'))

    setInvalidCodeAttempts(0)
    history.push('/register/confirm-sms')

    setReSend(false)
    setTimer(60)
    window.location.reload()
  }, [userData, configData, history, setConfigData, setInvalidCodeAttempts])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Header />

      <Container>
        <Content>
          <span>
            Digite aqui o código de verificação que acabamos de te enviar via{' '}
            {contato}
          </span>
          <Form ref={formRef} onSubmit={handleSubmit}>
            <InputSMSCode name="codeSMS" size={sizeCode} formRef={formRef} />
          </Form>

          <Collapse in={open}>
            <AlertContent>
              <div>
                <FiAlertCircle />
                <p>Código incorreto!</p>
              </div>
              <button type="button" onClick={() => window.location.reload()}>
                Limpar
              </button>
            </AlertContent>
          </Collapse>

          <Timer>00:{timer < 10 ? `0${timer}` : timer}</Timer>
          <p>Não está recebendo o código? Sem problemas!</p>
          <p>
            Clique em <strong>reenviar</strong> para receber um novo código
          </p>
          <Button
            onClick={handleReSend}
            type="button"
            color="orange"
            disabled={!reSend}
          >
            Reenviar
          </Button>
          <LinkBack to="/register">Quero trocar a forma de contato</LinkBack>
        </Content>
      </Container>
    </>
  )
}

export default ConfirmSMS
